export default __webpack_public_path__ + "static/media/footer-bg.15f2750f.png";